/* eslint-disable */
import * as React from 'react';
import Button from './defaultButton';
import injectSheet from 'react-jss';

const styleSheet = (theme: any) => ({
  input: {
    '&::placeholder': {
      textOverflow: 'ellipsis !important',
      color: '#b7c1e1',
    },
    '&:-ms-input-placeholder': {
      textOverflow: 'ellipsis !important',
      color: '#b7c1e1',
    },
    outline: 0,
    width: '100%',
    height: '72px',
    objectFit: 'contain',
    borderRadius: '6px',
    border: 'solid 2px #b7c1e1',
    boxSizing: 'border-box',
    padding: '24px 27px',
    fontSize: '24px',
    color: '#4f5b84',
  },
  label: {
    ...theme.label,
    marginLeft: '20px',
    display: 'block',
    textAlign: 'left',
    paddingLeft: '9px',
    marginBottom: '14px',
    color: '#223762',
    fontWeight: '800',
    '@media (max-width: 740px)': {
      marginLeft: '0',
      paddingLeft: '0',
    },
  },
  wrapper: {
    textAlign: 'left',
    '& > button': {
      margin: '0 16px',
      marginBottom: '50px',
    },
    // "& > :first-child": {
    //   marginLeft: "0"
    // },
    // "& > :last-child": {
    //   marginRight: "0"
    // }
    '@media (max-width: 1000px)': {
      maxWidth: '550px',
      margin: '0 auto',
    },
    '@media (max-width: 740px)': {
      maxWidth: '100%',
      '& > button': {
        width: '100%',
        margin: '0',
        marginBottom: '24px',
      },
    },
  },
  '@media (max-width: 768px)': {
    label: {
      fontSize: '10px',
    },
  },
});

interface Props {
  onChange?: (e: object) => void;
  field: any;
  classes?: any;
  error?: boolean;
  label?: string;
  name?: string;
}

const ButtonList: React.FC<Props> = props => {
  const clickHandler = (event: React.ChangeEvent<any>) => {
    let response = {
      target: {
        value: event.target.value,
        fieldId: props.field.fieldId,
        type: props.field.inputType,
      },
    };
    props.onChange ? props.onChange(response) : null;
  };

  return (
    <div className={props.classes.wrapper} data-name={props.name}>
      <label className={props.classes.label}>
        {props.field.label || 'Label'}
      </label>
      {props.field.list.map((item: any, index: number) => {
        return (
          <Button
            key={index}
            value={item.value}
            error={props.error || false}
            onClick={clickHandler}
          >
            {item.label}
          </Button>
        );
      })}
    </div>
  );
};

export default injectSheet(styleSheet)(ButtonList);
